/*global google*/
import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { notification, Modal, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { MaxiColors } from "../../../../theme";
import {
  RepairMarkerButton,
  // RepairPolylineButton,
} from "../../../../components";
import {
  setRepairDetail,
  decode,
  saveRepairPoint,
} from "../../../../actions/boldgroup/repairPointAction";
// import { numericInput } from "../../../../utils/utils";
import CreateRepairSiteDetail from "./CreateRepairSiteDetail";
import CreateRepairSJDetail from "./CreateRepairSJDetail";
import CreateRepairCoreDetail from "./CreateRepairCoreDetail";

const { confirm } = Modal;
// const optionFiberType = [
//   { code: 1, name: "F(8)" },
//   { code: 2, name: "ADSS" },
//   { code: 3, name: "ARMOR" },
//   { code: 4, name: "F(8)ADSS" },
//   { code: 5, name: "F(8)ARMOR" },
//   { code: 6, name: "PE ADSS" },
//   { code: 7, name: "WDF(8)" },
//   { code: 8, name: "ADSS_ARMOR" },
//   { code: 9, name: "Others" },
//   { code: 10, name: "ADSS-TEST" },
//   { code: 11, name: "Frp" },
//   { code: 12, name: "Rodent" },
//   { code: 13, name: "ARSS Armored" },
//   { code: 14, name: "ARSS Rodent" },
//   { code: 15, name: "Air Blown Fiber" },
//   { code: 16, name: "Air Blown Cable" },
// ];

const RepairTypeCore = ({ onSubmit }) => {
  const { repairDetail } = useSelector((state) => ({
    repairDetail: state.repairPoint?.repairDetail,
  }));
  const dispatch = useDispatch();

  const handleConfirmSaveRepairPoint = (request) => {
    confirm({
      title: "Do you Want to save item ?",
      icon: <ExclamationCircleOutlined />,
      content: `ต้องการบันทึกประเภทการซ่อม ${repairDetail.name}`,
      onOk() {
        return handleSaveRepairPoint(request)
          .then(() => {
            notification.success({
              message: "Success",
              description: "บันทึกรายการซ่อมสำเร็จ",
            });
            onSubmit();
          })
          .catch((error) => {
            notification.error({
              message: "เกิดข้อผิดพลาด",
              description: error.message,
            });
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleSaveRepairPoint = useCallback(
    async (request) => {
      try {
        await dispatch(saveRepairPoint(request));
      } catch (err) {
        throw err;
      }
    },
    [dispatch]
  );

  // const handleSetPolylineDetil = (stationCode, key, value) => {
  //   dispatch(
  //     setRepairDetail({
  //       ...repairDetail,
  //       polylines: repairDetail.polylines.map((s, i) => {
  //         if (s.stationCode === stationCode) {
  //           return { ...s, [key]: value };
  //         }
  //         return s;
  //       }),
  //     })
  //   );
  // };
  useEffect(() => {
    const originSite = repairDetail.markers.find(
      (f) => f.stationCode === 1 && f.layerCode === "SITE"
    );
    const destinationSite = repairDetail.markers.find(
      (f) => f.stationCode === 2 && f.layerCode === "SITE"
    );

    if (
      originSite &&
      destinationSite &&
      originSite.latitude &&
      originSite.longitude &&
      destinationSite.latitude &&
      destinationSite.longitude &&
      !repairDetail.polylines.length
    ) {
      const DirectionsService = new google.maps.DirectionsService();

      DirectionsService.route(
        {
          origin: new google.maps.LatLng(
            originSite.latitude,
            originSite.longitude
          ),
          destination: new google.maps.LatLng(
            destinationSite.latitude,
            destinationSite.longitude
          ),
          travelMode: google.maps.TravelMode.WALKING,
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            const directions = decode(result.routes[0].overview_polyline);
            dispatch(
              setRepairDetail({
                ...repairDetail,
                polylines: [
                  ...repairDetail.polylines,
                  {
                    coordinate: directions.map((m) => ({
                      ...m,
                      lat: m.latitude,
                      lng: m.longitude,
                    })),
                  },
                ],
              })
            );
            console.log("walkingPath", directions);
          } else {
            console.error(`error fetching directions ${result}`);
          }
        }
      );
    }

    const originSJ = repairDetail.markers.find(
      (f) => f.stationCode === 1 && f.layerCode === "SJ"
    );
    const destinationSJ = repairDetail.markers.find(
      (f) => f.stationCode === 2 && f.layerCode === "SJ"
    );

    if (
      originSJ &&
      destinationSJ &&
      originSJ.latitude &&
      originSJ.longitude &&
      destinationSJ.latitude &&
      destinationSJ.longitude &&
      repairDetail.polylines.length === 1
    ) {
      const { coordinate } = repairDetail.polylines[0];
      const slopesOrigin = coordinate.map((s) => {
        const slope = Math.sqrt(
          (originSJ.latitude - s.latitude) ** 2 +
            (originSJ.longitude - s.longitude) ** 2
        );
        return slope;
      });
      const indexMinSlopeOrigin = slopesOrigin.indexOf(
        Math.min(...slopesOrigin)
      );

      const slopesDestination = coordinate.map((s) => {
        const slope = Math.sqrt(
          (destinationSJ.latitude - s.latitude) ** 2 +
            (destinationSJ.longitude - s.longitude) ** 2
        );
        return slope;
      });

      const indexMinSlopeDestination = slopesDestination.indexOf(
        Math.min(...slopesDestination)
      );

      const lineOrigin = coordinate.slice(0, indexMinSlopeOrigin);
      const lineCenter = coordinate.slice(
        indexMinSlopeOrigin - 1,
        indexMinSlopeDestination
      );
      const lineDestination = coordinate.slice(
        indexMinSlopeDestination - 1,
        coordinate.length - 1
      );

      const fiberOrigin = {
        stationCode: 1,
        description: "Origin",
        coordinate: lineOrigin,
        markLengthStart: 0,
        markLengthEnd: 0,
        fiberTypeID: "",
        distanceFiber: 0,
        remark: "",
      };

      const fiberCenter = {
        stationCode: 3,
        description: "Center",
        coordinate: lineCenter,
        markLengthStart: 0,
        markLengthEnd: 0,
        fiberTypeID: "",
        distanceFiber: 0,
        remark: "",
      };

      const fiberDestination = {
        stationCode: 2,
        description: "Destination",
        coordinate: lineDestination,
        markLengthStart: 0,
        markLengthEnd: 0,
        fiberTypeID: "",
        distanceFiber: 0,
        remark: "",
      };

      dispatch(
        setRepairDetail({
          ...repairDetail,
          polylines: [fiberOrigin, fiberCenter, fiberDestination],
        })
      );
      notification.success({
        message: "กรุณากรอกข้อมูล",
        description: "กรอกข้อมูลของเส้น Fiber",
      });
    }
    return () => {};
  }, [dispatch, repairDetail]);
  return (
    <div>
      <div className="row">
        {repairDetail.markers.map((item, index) => (
          <div key={index} className="col-12">
            <RepairMarkerButton
              active={item.active}
              left={<img src={item.icon} alt="" />}
              title={item.description}
              onClick={() => {
                dispatch(
                  setRepairDetail({
                    ...repairDetail,
                    markers: repairDetail.markers.map((s, i) => {
                      if (i === index) {
                        return { ...s, active: !s.active };
                      }
                      return { ...s, active: false };
                    }),
                    polylines: repairDetail.polylines.map((m) => ({
                      ...m,
                      active: false,
                    })),
                  })
                );
              }}
            />
            {item.active && (
              <>
                {item.layerCode === "SITE" && (
                  <CreateRepairSiteDetail item={item} index={index} />
                )}
                {item.layerCode === "SJ" && (
                  <CreateRepairSJDetail item={item} index={index} />
                )}
                {item.layerCode === "CORE" && (
                  <CreateRepairCoreDetail item={item} index={index} />
                )}
              </>
            )}
          </div>
        ))}
        {/* {repairDetail.polylines
          .filter((f) => f.stationCode === 3)
          .map((item, index) => (
            <div key={index} className="col-12">
              <RepairPolylineButton
                active={item.active}
                left={
                  <div
                    style={{
                      width: 20,
                      height: 4,
                      backgroundColor: MaxiColors.DANGER,
                    }}
                  />
                }
                title={"Fiber"}
                onClick={() => {
                  dispatch(
                    setRepairDetail({
                      ...repairDetail,
                      polylines: repairDetail.polylines.map((s, i) => {
                        if (s.stationCode === item.stationCode) {
                          return { ...s, active: !s.active };
                        }
                        return { ...s, active: false };
                      }),
                      markers: repairDetail.markers.map((m) => ({
                        ...m,
                        active: false,
                      })),
                    })
                  );
                }}
              />
              {item.active && (
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label className="mb-0">Mark Length Start</label>
                      <input
                        className="form-control form-control-sm"
                        value={item.markLengthStart || ""}
                        onChange={(event) => {
                          const { value } = event.target;
                          handleSetPolylineDetil(
                            item.stationCode,
                            "markLengthStart",
                            numericInput(value)
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label className="mb-0">Mark Length End</label>
                      <input
                        className="form-control form-control-sm"
                        value={item.markLengthEnd || ""}
                        onChange={(event) => {
                          const { value } = event.target;
                          handleSetPolylineDetil(
                            item.stationCode,
                            "markLengthEnd",
                            numericInput(value)
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="mb-0">ประเภทสาย</label>
                      <select
                        className="form-control form-control-sm"
                        value={item.fiberTypeID || ""}
                        onChange={(event) => {
                          const { value } = event.target;
                          handleSetPolylineDetil(
                            item.stationCode,
                            "fiberTypeID",
                            value
                          );
                        }}
                      >
                        <option value="">โปรดเลือก</option>
                        {optionFiberType.map((item, i) => (
                          <option key={i} value={item.code}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="mb-0">ระยะสายที่ใช้</label>
                      <input
                        className="form-control form-control-sm"
                        value={
                          +numericInput(item.markLengthEnd) -
                            +numericInput(item.markLengthStart) || ""
                        }
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="mb-0">หมายเหตุ</label>
                      <textarea
                        className="form-control form-control-sm"
                        value={item.remark || ""}
                        onChange={(event) => {
                          const { value } = event.target;
                          handleSetPolylineDetil(
                            item.stationCode,
                            "remark",
                            value
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))} */}
      </div>
      <div className="row justify-content-center mt-5">
        <div className="col-12">
          <Button
            // className="btn"
            style={{
              backgroundColor: MaxiColors.ACCENT,
              width: "100%",
            }}
            onClick={() => {
              const validation = repairDetail.markers.find(
                (f) => !f.latitude || !f.longitude
              );

              if (validation) {
                notification.error({
                  message: "เกิดข้อผิดพลาด",
                  description: `ไม่พบพิกัดของ ${validation.layerCode.toLowerCase()} (${
                    validation.description
                  })`,
                });
                return;
              }

              const duplicateLoop = repairDetail.markers
                .filter((f) => f.layerCode === "SJ")
                .map((m) => ({ ...m, layerCode: "LOOP" }));
              const request = {
                ...repairDetail,
                markers: [...repairDetail.markers, ...duplicateLoop],
              };
              console.log("request", request);
              handleConfirmSaveRepairPoint(request);
            }}
          >
            <span
              className="default-thai-font"
              style={{ color: MaxiColors.PRIMARY }}
            >
              CONFIRM
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RepairTypeCore;
